import mdast from 'mdast';

import { SerializeOptions } from '@lumapps/wrex/serialization/markdown/toMarkdown/types';

export const LIST_ELEMENTS: SerializeOptions['elements'] = {
    'unordered-list': (_, children) => ({ type: 'list', ordered: false, children }) as mdast.List,
    'ordered-list': (_, children) => ({ type: 'list', ordered: true, children }) as mdast.List,
    'list-item': (_, children) => ({ type: 'listItem', children }) as mdast.ListItem,
};
